<template>
  <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules">
    <div class="input_wrapper">
      <label :for="name">{{ label }}</label>

      <input
        :name="name"
        :type="type"
        :placeholder="placeholder"
        :value="value"
        @input="updateValue"
      />
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: false,
      default: "",
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      default: " ",
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style></style>
